/** Marca da Gestora no painel: quadrado marinho com o G e um ponto roxo. */
export function Logo({ className = '' }: { className?: string }) {
  return (
    <span className={`inline-flex items-center gap-2 ${className}`}>
      <span aria-hidden className="relative grid size-8 place-items-center rounded-[10px] bg-gradient-to-br from-brand-700 to-brand-900 text-[15px] font-bold text-white shadow-[inset_0_1px_0_rgb(255_255_255/0.35)]">
        G
        <span className="absolute -top-0.5 -right-0.5 size-2 rounded-full bg-violet ring-2 ring-white" />
      </span>
      <span className="text-lg font-semibold tracking-tight text-ink">Gestora</span>
    </span>
  );
}
